import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './multilang/eng.json';
import fr from './multilang/fr.json';

const getPreferredLanguage = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const settings = JSON.parse(localStorage.getItem('settings'));

    if (user?.preferredLanguage) {
      console.log('User preferred language found:', user.preferredLanguage);
      return user.preferredLanguage;
    } else if (settings?.language) {
      console.log('Settings language found:', settings.language);
      return settings.language;
    }
  } catch (err) {
    console.warn('Could not parse language preference:', err);
  }

  return 'fr';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    lng: getPreferredLanguage(),
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
    debug: true,
  });


export const applyPreferredLanguage = () => {
  const lang = getPreferredLanguage();
  i18n.changeLanguage(lang);
};

export default i18n;
